import React, { useEffect, useState } from 'react';
import { Collapse, List, ListItem, ListItemButton } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import CityModal from "./CityModal";
import { logoutUser } from '../redux/userSlice';
import { getAllPrescriptionCount } from '../redux/prescriptionSlice';
import { useSelector, useDispatch } from "react-redux";

const ListNavigation = () => {
    const dispatch = useDispatch();
    const [selectedIndex, setSelectedIndex] = React.useState(0);
    const [selectedDropdown, setSelectedDropdown] = React.useState(0);
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();
    const [openLogoutModal, setOpenLogoutModal] = useState(false);

    const handleListItemClick = (
        event,
        index
    ) => {
        if (index === 2) {
            setOpen(!open)
            setSelectedIndex(10);
        } else if (index === 0) {
            setOpen(false)
            setSelectedDropdown(10)
            navigate("/prescription")
        } else if (index === 1) {
            setOpen(false)
            setSelectedDropdown(10)
            navigate("/customers")
        } else if (index === 3) {
            setSelectedIndex(10);
            setOpenLogoutModal(true)
        }
    };

    const handleSelectedDropdown = (event, index) => {
        setSelectedDropdown(index)
    }

    useEffect(() => {
        dispatch(getAllPrescriptionCount())
    }, [])
    const allPrescriptionsCount = useSelector(state => state?.prescription?.allPrescriptionsCount) ?? 0

    const lists = [
        {
            name: "Prescription",
            svg: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25"
                fill="none">
                <path
                    d="M14.5 2.5H6C5.46957 2.5 4.96086 2.71071 4.58579 3.08579C4.21071 3.46086 4 3.96957 4 4.5V20.5C4 21.0304 4.21071 21.5391 4.58579 21.9142C4.96086 22.2893 5.46957 22.5 6 22.5H18C18.5304 22.5 19.0391 22.2893 19.4142 21.9142C19.7893 21.5391 20 21.0304 20 20.5V8L14.5 2.5Z"
                    stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M14 2.5V8.5H20" stroke="black" strokeWidth="2" strokeLinecap="round"
                    strokeLinejoin="round" />
                <path d="M16 13.5H8" stroke="black" strokeWidth="2" strokeLinecap="round"
                    strokeLinejoin="round" />
                <path d="M16 17.5H8" stroke="black" strokeWidth="2" strokeLinecap="round"
                    strokeLinejoin="round" />
                <path d="M10 9.5H8" stroke="black" strokeWidth="2" strokeLinecap="round"
                    strokeLinejoin="round" />
            </svg>,
            alert: allPrescriptionsCount ?? 0
        },
        {
            name: "Customers",
            svg: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                <path
                    d="M16 21.5V19.5C16 18.4391 15.5786 17.4217 14.8284 16.6716C14.0783 15.9214 13.0609 15.5 12 15.5H6C4.93913 15.5 3.92172 15.9214 3.17157 16.6716C2.42143 17.4217 2 18.4391 2 19.5V21.5"
                    stroke="#393939" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M9 11.5C11.2091 11.5 13 9.70914 13 7.5C13 5.29086 11.2091 3.5 9 3.5C6.79086 3.5 5 5.29086 5 7.5C5 9.70914 6.79086 11.5 9 11.5Z"
                    stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M22 21.5009V19.5009C21.9993 18.6146 21.7044 17.7536 21.1614 17.0532C20.6184 16.3527 19.8581 15.8524 19 15.6309"
                    stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M16 3.63086C16.8604 3.85116 17.623 4.35156 18.1676 5.05317C18.7122 5.75478 19.0078 6.61769 19.0078 7.50586C19.0078 8.39403 18.7122 9.25694 18.1676 9.95855C17.623 10.6602 16.8604 11.1606 16 11.3809"
                    stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>,
            navigate: "/customers"
        },
        {
            name: "Settings",
            svg: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                <path
                    d="M12.22 2.5H11.78C11.2496 2.5 10.7409 2.71071 10.3658 3.08579C9.99072 3.46086 9.78 3.96957 9.78 4.5V4.68C9.77964 5.03073 9.68706 5.37519 9.51154 5.67884C9.33602 5.98248 9.08374 6.23464 8.78 6.41L8.35 6.66C8.04596 6.83554 7.70108 6.92795 7.35 6.92795C6.99893 6.92795 6.65404 6.83554 6.35 6.66L6.2 6.58C5.74107 6.31526 5.19584 6.24344 4.684 6.38031C4.17217 6.51717 3.73555 6.85154 3.47 7.31L3.25 7.69C2.98526 8.14893 2.91345 8.69416 3.05031 9.206C3.18717 9.71783 3.52154 10.1544 3.98 10.42L4.13 10.52C4.43228 10.6945 4.68362 10.9451 4.85905 11.2468C5.03448 11.5486 5.1279 11.891 5.13 12.24V12.75C5.1314 13.1024 5.03965 13.449 4.86405 13.7545C4.68844 14.0601 4.43521 14.3138 4.13 14.49L3.98 14.58C3.52154 14.8456 3.18717 15.2822 3.05031 15.794C2.91345 16.3058 2.98526 16.8511 3.25 17.31L3.47 17.69C3.73555 18.1485 4.17217 18.4828 4.684 18.6197C5.19584 18.7566 5.74107 18.6847 6.2 18.42L6.35 18.34C6.65404 18.1645 6.99893 18.0721 7.35 18.0721C7.70108 18.0721 8.04596 18.1645 8.35 18.34L8.78 18.59C9.08374 18.7654 9.33602 19.0175 9.51154 19.3212C9.68706 19.6248 9.77964 19.9693 9.78 20.32V20.5C9.78 21.0304 9.99072 21.5391 10.3658 21.9142C10.7409 22.2893 11.2496 22.5 11.78 22.5H12.22C12.7504 22.5 13.2591 22.2893 13.6342 21.9142C14.0093 21.5391 14.22 21.0304 14.22 20.5V20.32C14.2204 19.9693 14.3129 19.6248 14.4885 19.3212C14.664 19.0175 14.9163 18.7654 15.22 18.59L15.65 18.34C15.954 18.1645 16.2989 18.0721 16.65 18.0721C17.0011 18.0721 17.346 18.1645 17.65 18.34L17.8 18.42C18.2589 18.6847 18.8042 18.7566 19.316 18.6197C19.8278 18.4828 20.2645 18.1485 20.53 17.69L20.75 17.3C21.0147 16.8411 21.0866 16.2958 20.9497 15.784C20.8128 15.2722 20.4785 14.8356 20.02 14.57L19.87 14.49C19.5648 14.3138 19.3116 14.0601 19.136 13.7545C18.9604 13.449 18.8686 13.1024 18.87 12.75V12.25C18.8686 11.8976 18.9604 11.551 19.136 11.2455C19.3116 10.9399 19.5648 10.6862 19.87 10.51L20.02 10.42C20.4785 10.1544 20.8128 9.71783 20.9497 9.206C21.0866 8.69416 21.0147 8.14893 20.75 7.69L20.53 7.31C20.2645 6.85154 19.8278 6.51717 19.316 6.38031C18.8042 6.24344 18.2589 6.31526 17.8 6.58L17.65 6.66C17.346 6.83554 17.0011 6.92795 16.65 6.92795C16.2989 6.92795 15.954 6.83554 15.65 6.66L15.22 6.41C14.9163 6.23464 14.664 5.98248 14.4885 5.67884C14.3129 5.37519 14.2204 5.03073 14.22 4.68V4.5C14.22 3.96957 14.0093 3.46086 13.6342 3.08579C13.2591 2.71071 12.7504 2.5 12.22 2.5Z"
                    stroke="#393939" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M12 15.5C13.6569 15.5 15 14.1569 15 12.5C15 10.8431 13.6569 9.5 12 9.5C10.3431 9.5 9 10.8431 9 12.5C9 14.1569 10.3431 15.5 12 15.5Z"
                    stroke="#393939" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>,
            dropdown_list: [
                {
                    name: "General",
                    svg: <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                        <path d="M20.5 7.5H11.5" stroke="#393939" strokeWidth="1.5" strokeLinecap="round"
                            strokeLinejoin="round" />
                        <path d="M14.5 17.5H5.5" stroke="#393939" strokeWidth="1.5" strokeLinecap="round"
                            strokeLinejoin="round" />
                        <path
                            d="M17.5 20.5C19.1569 20.5 20.5 19.1569 20.5 17.5C20.5 15.8431 19.1569 14.5 17.5 14.5C15.8431 14.5 14.5 15.8431 14.5 17.5C14.5 19.1569 15.8431 20.5 17.5 20.5Z"
                            stroke="#393939" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path
                            d="M7.5 10.5C9.15685 10.5 10.5 9.15685 10.5 7.5C10.5 5.84315 9.15685 4.5 7.5 4.5C5.84315 4.5 4.5 5.84315 4.5 7.5C4.5 9.15685 5.84315 10.5 7.5 10.5Z"
                            stroke="#393939" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>,
                    navigate: "/settings/general"
                },
                // {
                //     name: "Team Members",
                //     svg: <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                //         <path
                //             d="M16.5 21.5V19.5C16.5 18.4391 16.0786 17.4217 15.3284 16.6716C14.5783 15.9214 13.5609 15.5 12.5 15.5H6.5C5.43913 15.5 4.42172 15.9214 3.67157 16.6716C2.92143 17.4217 2.5 18.4391 2.5 19.5V21.5"
                //             stroke="#393939" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                //         <path
                //             d="M9.5 11.5C11.7091 11.5 13.5 9.70914 13.5 7.5C13.5 5.29086 11.7091 3.5 9.5 3.5C7.29086 3.5 5.5 5.29086 5.5 7.5C5.5 9.70914 7.29086 11.5 9.5 11.5Z"
                //             stroke="#393939" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                //         <path
                //             d="M19.5 13.5C20.6046 13.5 21.5 12.6046 21.5 11.5C21.5 10.3954 20.6046 9.5 19.5 9.5C18.3954 9.5 17.5 10.3954 17.5 11.5C17.5 12.6046 18.3954 13.5 19.5 13.5Z"
                //             stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                //         <path d="M19.5 8.5V9.5" stroke="black" strokeWidth="2" strokeLinecap="round"
                //             strokeLinejoin="round" />
                //         <path d="M19.5 13.5V14.5" stroke="black" strokeWidth="2" strokeLinecap="round"
                //             strokeLinejoin="round" />
                //         <path d="M22.1005 10L21.2305 10.5" stroke="black" strokeWidth="2" strokeLinecap="round"
                //             strokeLinejoin="round" />
                //         <path d="M17.7704 12.5L16.9004 13" stroke="black" strokeWidth="2" strokeLinecap="round"
                //             strokeLinejoin="round" />
                //         <path d="M22.1005 13L21.2305 12.5" stroke="black" strokeWidth="2" strokeLinecap="round"
                //             strokeLinejoin="round" />
                //         <path d="M17.7704 10.5L16.9004 10" stroke="black" strokeWidth="2" strokeLinecap="round"
                //             strokeLinejoin="round" />
                //     </svg>,
                //     navigate: "/settings/member-settings"
                // },
                {
                    name: "Security",
                    svg: <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                        <path
                            d="M19.5 11.5H5.5C4.39543 11.5 3.5 12.3954 3.5 13.5V20.5C3.5 21.6046 4.39543 22.5 5.5 22.5H19.5C20.6046 22.5 21.5 21.6046 21.5 20.5V13.5C21.5 12.3954 20.6046 11.5 19.5 11.5Z"
                            stroke="#393939" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path
                            d="M7.5 11.5V7.5C7.5 6.17392 8.02678 4.90215 8.96447 3.96447C9.90215 3.02678 11.1739 2.5 12.5 2.5C13.8261 2.5 15.0979 3.02678 16.0355 3.96447C16.9732 4.90215 17.5 6.17392 17.5 7.5V11.5"
                            stroke="#393939" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>,
                    navigate: "/settings/security"
                }

            ],
        },
        {
            name: "Logout",
            svg: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                <path
                    d="M9 21.5H5C4.46957 21.5 3.96086 21.2893 3.58579 20.9142C3.21071 20.5391 3 20.0304 3 19.5V5.5C3 4.96957 3.21071 4.46086 3.58579 4.08579C3.96086 3.71071 4.46957 3.5 5 3.5H9"
                    stroke="#F95457" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M16 17.5L21 12.5L16 7.5" stroke="#F95457" strokeWidth="1.5" strokeLinecap="round"
                    strokeLinejoin="round" />
                <path d="M21 12.5H9" stroke="#F95457" strokeWidth="1.5" strokeLinecap="round"
                    strokeLinejoin="round" />
            </svg>,
        }
    ];

    useEffect(() => {
        const pathSegments = window.location.pathname.split('/');
        const firstSegment = pathSegments[1]; // Get the first segment after splitting
        if (firstSegment === 'prescription') {
            setSelectedIndex(0)
        } else if (firstSegment === 'customers') {
            setSelectedIndex(1)
        }
    }, [window.location.pathname]);

    return (
        <>
            <CityModal
                name='Log out'
                handleClose={() => setOpenLogoutModal(false)}
                open={openLogoutModal}
                content={
                    <div className='content-wrapper'>
                        <div className='top-part'>
                            <h1>You are attempting to log out of City Pharmacy</h1>
                            <p>Are you sure?</p>
                        </div>
                        <div className='buttons-modal'>
                            <button className='red-button' onClick={() => dispatch(logoutUser())}>Log Out</button>
                            <button onClick={() => setOpenLogoutModal(false)} className='white-button'>Cancel</button>
                        </div>
                    </div>
                }
            />
            <div className='list-navigation-wrapper'>
                <List>
                    {lists.map((list, index) =>
                    (<div key={index}>
                        <ListItem disablePadding>
                            <ListItemButton selected={selectedIndex === index && selectedIndex !== 2}
                                onClick={(event) => handleListItemClick(event, index)}
                                className="inside-list">
                                {list.svg}
                                <h1 className={`${selectedIndex === index && 'bold'} ${list.name === "Logout" && 'red'}`}>{list.name}</h1>
                                {(list.alert && list.alert > 0) && <div className='alert'>
                                    <p>{list.alert > 0 && list.alert}</p>
                                </div>}
                                {list.name === 'Settings' ? open ? <ExpandLess /> : <ExpandMore /> : null}
                            </ListItemButton>
                        </ListItem>
                        {list.name === "Settings" &&
                            <Collapse in={open} timeout="auto" unmountOnExit>
                                <List className='collapse' component="div" disablePadding>
                                    {list.dropdown_list.map((dropdown, index) =>
                                        <ListItemButton key={index} selected={selectedDropdown === index} onClick={(event) => {
                                            navigate(dropdown.navigate);
                                            handleSelectedDropdown(event, index)
                                        }} className="inside-list">
                                            {dropdown.svg}
                                            <p>
                                                {dropdown.name}
                                            </p>
                                        </ListItemButton>
                                    )}
                                </List>
                            </Collapse>
                        }
                    </div>)
                    )}
                </List>
            </div>
        </>
    );
};

export default ListNavigation;